<template>
  <div v-if="!isLoading">
    <div class="content_accion">
      <div style="display: flex">
        <v-text-field
          v-model="search"
          label="Búsqueda"
          prepend-inner-icon="mdi-magnify"
          single-line
          variant="outlined"
          hide-details
          class="filter"
          :disabled="isLoading || isLoadingGeneral"
        ></v-text-field>

        <v-select
          class="ml-3 filter"
          v-model="formGroup.data.id_grupo"
          label="Grupos"
          variant="outlined"
          :items="arrGroupList"
          item-title="nombre"
          item-value="id_grupo"
          prepend-inner-icon="mdi-account-group"
          @update:model-value="updateForm()"
          :disabled="isLoading || isLoadingGeneral"
        ></v-select>

        <v-select
          class="ml-3 filter"
          v-model="formGroup.data.status"
          label="Estados"
          variant="outlined"
          :items="arrStatus"
          item-title="title"
          item-value="value"
          prepend-inner-icon="mdi-timelapse"
          @update:model-value="updateForm()"
          :disabled="isLoading || isLoadingGeneral || registerValidate()"
        ></v-select>
      </div>
      <div>
        <v-btn
          icon="mdi-reload"
          size="small"
          variant="outlined"
          color="indigo-darken-3"
          class="mr-2"
          :disabled="isLoading || reloadValidate() || isLoadingGeneral"
          @click="updateForm()"
        ></v-btn>
        <v-btn
          v-if="userType === 'Administrador'"
          prepend-icon="mdi-plus"
          color="indigo-darken-3"
          class="elevation-0 text-none"
          :disabled="isLoading || isLoadingGeneral || registerValidate()"
          text="Registrar"
          @click="openDialog('R')"
        ></v-btn>
      </div>
    </div>
    <div class="container_table">
      <v-data-table
        :items="dataSource.data"
        :headers="dataSource.headers"
        :search="search"
        :loading="isLoading || isLoadingGeneral"
        no-data-text="Sin datos para mostrar"
        loading-text="Cargando información... Espere un momento"
        class="content_table"
      >
        <template v-slot:[`item.acciones`]="{ item }">
          <tr>
            <td>
              <div class="actions" v-if="item.estatus === 'en_proceso'">
                <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                <v-btn color="indigo-darken-3" @click="openDialog('E', item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </div>
              <div class="actions">
                <v-tooltip activator="parent" location="top"
                  >Ver Grafica</v-tooltip
                >
                <v-btn color="indigo-darken-3" @click="openDialog('G', item)">
                  <v-icon>mdi-check</v-icon>
                </v-btn>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
  <div v-if="isLoading" class="content_load h-100">
    <v-progress-circular
      :size="100"
      :width="7"
      color="primary"
      indeterminate
    ></v-progress-circular>
    <i>Espere un Momento</i>
    <div>Cargando la Información</div>
  </div>

  <!--Dialog de registro-->
  <template>
    <v-dialog v-model="dialogForm.open" width="300px" persistent>
      <v-card>
        <v-card-title class="text-h5">{{ dialogForm.title }}</v-card-title>
        <v-card-text>
          <form class="override_content_flex">
            <div class="col-flex-12">
              <v-text-field
                label="Meta"
                variant="outlined"
                class="w-100"
                type="number"
                onkeydown="return event.key !== 'e'"
                v-model="formGroup.data.meta"
                :rules="formGroup.rules.meta"
              ></v-text-field>
            </div>
            <div class="col-flex-12" v-if="dialogForm.type === 'R'">
              <v-text-field
                label="Fecha Inicio"
                type="date"
                variant="outlined"
                class="w-100"
                v-model="formGroup.data.fecha_inicio"
                :rules="formGroup.rules.fecha_inicio"
              ></v-text-field>
            </div>
            <div class="col-flex-12" v-if="dialogForm.type === 'R'">
              <v-text-field
                label="Fecha Fin"
                type="date"
                variant="outlined"
                class="w-100"
                v-model="formGroup.data.fecha_fin"
                :rules="formGroup.rules.fecha_fin"
              ></v-text-field>
            </div>
            <div class="col-flex-12" v-if="dialogForm.type === 'E'">
              <v-select
                class="w-100"
                label="Estados"
                variant="outlined"
                v-model="formGroup.data.status"
                :items="arrStatus"
                item-title="title"
                item-value="value"
                prepend-inner-icon="mdi-timelapse"
              ></v-select>
            </div>
          </form>
        </v-card-text>
        <v-card-actions class="actions_buttons">
          <v-btn
            variant="flat"
            class="text-none"
            color="red"
            prepend-icon="mdi-close"
            @click="closeDialog()"
            text="Cerrar"
            :disabled="dialogForm.loading"
          ></v-btn>
          <v-btn
            variant="flat"
            class="text-none"
            color="indigo-darken-3"
            prepend-icon="mdi-content-save"
            :loading="dialogForm.loading"
            :disabled="dialogForm.loading || validateForm()"
            @click="dialogConfirmate.open = true"
            text="Aceptar"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <!--Dialog Confirmar-->
  <template>
    <v-dialog v-model="dialogConfirmate.open" width="500px" persistent>
      <v-card>
        <v-card-title class="text-h5">Confirmación</v-card-title>
        <v-card-text>
          <div v-if="!dialogConfirmate.loading">
            <div class="text-center">
              <img src="@/assets/images/warning.png" />
            </div>
            <div class="description-text">
              <p v-if="dialogForm.type === 'R'">
                ¿Está seguro de registrar la gestión?
              </p>
              <p v-if="dialogForm.type === 'E'">
                ¿Está seguro de actualizar la gestión?
              </p>
            </div>
          </div>
          <div class="content_load" v-if="dialogConfirmate.loading">
            <v-progress-circular
              :size="100"
              :width="7"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <i>Espere un momento</i>
            <div>Guardando la información</div>
          </div>
        </v-card-text>
        <v-card-actions
          class="actions_buttons"
          v-if="!dialogConfirmate.loading"
        >
          <v-btn
            variant="flat"
            class="text-none"
            color="red"
            @click="cancelConfirmate()"
            text="Cancelar"
            prepend-icon="mdi-close"
          ></v-btn>
          <v-btn
            variant="flat"
            class="text-none"
            color="indigo-darken-3"
            prepend-icon="mdi-content-save"
            v-if="dialogForm.type === 'R'"
            @click="createGoal()"
            :loading="dialogConfirmate.loading"
            text="Aceptar"
          ></v-btn>
          <v-btn
            variant="flat"
            class="text-none"
            color="indigo-darken-3"
            prepend-icon="mdi-content-save"
            v-if="dialogForm.type === 'E'"
            @click="updateGoal()"
            :loading="dialogConfirmate.loading"
            text="Aceptar"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <!--Grafica-->
  <template>
    <v-dialog v-model="dialogGrafica.open" width="750px" persistent>
      <v-card>
        <v-card-title class="text-h5">Grafica</v-card-title>
        <v-card-text>
          <div v-if="!isLoading && !isLoadingGeneral">
            <apexchart
              height="400px"
              type="bar"
              :options="chartOptions"
              :series="series"
            ></apexchart>
          </div>
        </v-card-text>
        <v-card-actions class="actions_buttons">
          <v-btn
            variant="flat"
            class="text-none"
            color="red"
            prepend-icon="mdi-close"
            @click="dialogGrafica.open = false"
            text="Cerrar"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <SnackbarComponent :value="snackbarData" />
</template>

<script>
import SnackbarComponent from "@/components/Snackbar.vue";
import { EncryptService } from "@/services/EncryptService";
import { EstadisticaService } from "@/services/EstadisticaService";
import VueApexCharts from "vue3-apexcharts";
export default {
  name: "GruposMetas",
  components: {
    SnackbarComponent,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      search: "",
      isLoading: false,
      isLoadingGeneral: false,
      tab: null,
      snackbarData: {
        openSnackbar: false,
        description: "",
      },
      userType: "",
      arrGroupList: [],
      formGroup: {
        data: {
          id_grupo: null,
          status: null,
          meta: null,
          fecha_inicio: null,
          id_metaG: null,
          fecha_fin: null,
        },
        rules: {
          meta: [
            (value) => {
              if (value === null || value === undefined || value === "") {
                return `Este campo es obligatorio`;
              }

              if (value <= 0) {
                return `Este campo solo acepta valores positivos`;
              }
              return true;
            },
          ],
          fecha_inicio: [
            (value) => {
              if (value === null || value === undefined || value === "") {
                return `Este campo es obligatorio`;
              }
              return true;
            },
          ],
          fecha_fin: [
            (value) => {
              if (value === null || value === undefined || value === "") {
                return `Este campo es obligatorio`;
              }
              return true;
            },
          ],
        },
      },
      arrStatus: [
        { title: "En Proceso", value: "en_proceso" },
        { title: "Cancelada", value: "cancelada" },
        { title: "Completada", value: "completada" },
      ],
      dataSource: {
        data: [],
        headers: [
          { title: "Meta", key: "meta" },
          { title: "Fecha Inicio", key: "fecha_inicio" },
          { title: "Fecha Fin", key: "fecha_fin" },
          { title: "Última Actualización", key: "editado_por" },
          { title: "Acciones", key: "acciones" },
        ],
      },
      dialogForm: {
        open: false,
        loading: false,
        type: "R" | "E" | "G",
        title: "...",
      },
      dialogConfirmate: {
        open: false,
        title: `...`,
        description: `...`,
        loading: false,
      },
      formFilter: {
        data: {
          status: null,
          gestor: null,
        },
      },
      dialogGrafica: {
        open: false,
        title: `...`,
        description: `...`,
        loading: false,
      },
      series: [],
      chartOptions: {
        chart: {
          height: 350,
          type: "bar",
          id: "vuechart-example",
        },
        plotOptions: {
          bar: {
            columnWidth: "60%",
          },
        },
        colors: ["#00E396"],
        dataLabels: {
          enabled: true,
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          customLegendItems: ["Actual", "Meta"],
          markers: {
            fillColors: ["#00E396", "#775DD0"],
          },
        },
      },
    };
  },
  async created() {
    const ENC_TYPE_USER = localStorage.getItem("TIPO");
    this.userType = await EncryptService.decrypt(ENC_TYPE_USER);

    this.isLoading = true;
    await this.getGrupos();
    this.isLoading = false;
  },
  methods: {
    getGrupos: async function () {
      if (this.userType == "Administrador") {
        await EstadisticaService.getGruposAdmin(localStorage.getItem("TIPO"), null)
          .then((resp) => {
            if (!resp.error) {
              this.arrGroupList = resp.response;
            } else {
              this.snackbarData.description = `${resp.msg}`;
              this.snackbarData.openSnackbar = true;
            }
          })
          .catch((err) => {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: err,
            };
          });
      } else {
        const ID = localStorage.getItem("ID");
        const ENC_ID = await EncryptService.encrypt(`${ID}`);
        await EstadisticaService.getGruposSupervisor(ENC_ID)
          .then((resp) => {
            if (!resp.error) {
              this.arrGroupList = resp.response;
            } else {
              this.snackbarData.description = `${resp.msg}`;
              this.snackbarData.openSnackbar = true;
            }
          })
          .catch((err) => {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: err,
            };
          });
      }
    },
    reloadValidate: function () {
      const STATUS = this.formGroup.data.status;
      if (STATUS === null || STATUS === undefined || STATUS === "") {
        return true;
      }
      const ID_GRUPO = this.formGroup.data.id_grupo;
      if (ID_GRUPO === null || ID_GRUPO === undefined || ID_GRUPO === "") {
        return true;
      }
      return false;
    },
    registerValidate: function () {
      const ID_GRUPO = this.formGroup.data.id_grupo;
      if (ID_GRUPO === null || ID_GRUPO === undefined || ID_GRUPO === "") {
        return true;
      }
      return false;
    },
    updateForm: async function () {
      const ID_GRUPO = this.formGroup.data.id_grupo;
      const STATUS = this.formGroup.data.status;

      if (ID_GRUPO === null || ID_GRUPO === undefined || ID_GRUPO === "") {
        return;
      }
      if (STATUS === null || STATUS === undefined || STATUS === "") {
        return;
      }

      const ENC_ID_GRUPO = await EncryptService.encrypt(`${ID_GRUPO}`);

      await this.getGeneralGoals(STATUS, ENC_ID_GRUPO);
    },
    getGeneralGoals: async function (STATUS, ID_GRUPO) {
      this.isLoadingGeneral = true;
      this.isLoading = true;
      await EstadisticaService.getGeneralGoals("grupo", STATUS, ID_GRUPO).then(
        (responseData) => {
          if (!responseData.error) {
            this.dataSource.data = responseData.response;
          } else {
            this.snackbarData.description = `${responseData.msg}`;
            this.snackbarData.openSnackbar = true;
          }
        }
      );
      this.isLoading = false;
      this.isLoadingGeneral = false;
    },
    openDialog: function (TYPE, DATA) {
      this.dialogForm.type = TYPE;
      if (TYPE === "R") {
        this.dialogForm.title = `Registro de formulario`;
        this.dialogForm.open = true;
      }

      if (TYPE == "E") {
        this.dialogForm.title = `Actualización del formulario`;
        this.formGroup.data.meta = DATA.meta;
        this.formGroup.data.fecha_inicio = DATA.fecha_inicio;
        this.formGroup.data.fecha_fin = DATA.fecha_fin;
        this.formGroup.data.id_metaG = DATA.id_meta;
        this.formGroup.data.status = DATA.estatus;
        this.dialogForm.open = true;
      }

      if (TYPE == "G") {
        this.formGroup.data.id_metaG = DATA.id_meta;
        this.formGroup.data.fecha_inicio = DATA.fecha_inicio;
        this.formGroup.data.fecha_fin = DATA.fecha_fin;
        this.formGroup.data.meta = DATA.meta;
        this.formGroup.data.status = DATA.estatus;
        this.getDataGrafica();
        this.dialogGrafica.open = true;
      }
    },
    closeDialog: function () {
      this.formGroup.data.meta = null;
      this.formGroup.data.fecha_inicio = null;
      this.formGroup.data.status = null;
      this.formGroup.data.fecha_fin = null;
      this.formGroup.data.id_metaG = null;
      this.dialogForm.open = false;
    },
    validateForm: function () {
      const META = this.formGroup.data.meta;
      if (META === null || META === undefined || META === "") {
        return true;
      }
      const FECHA_INICIO = this.formGroup.data.fecha_inicio;
      if (
        FECHA_INICIO === null ||
        FECHA_INICIO === undefined ||
        FECHA_INICIO === ""
      ) {
        return true;
      }

      const FECHA_FIN = this.formGroup.data.fecha_fin;
      if (FECHA_FIN === null || FECHA_FIN === undefined || FECHA_FIN === "") {
        return true;
      }
      return false;
    },
    createGoal: async function () {
      this.dialogConfirmate.loading = true;
      let idGrupo = await EstadisticaService.encriptar(
        this.formGroup.data.id_grupo
      );

      let body = {
        meta: this.formGroup.data.meta,
        fecha_inicio: this.formGroup.data.fecha_inicio,
        fecha_fin: this.formGroup.data.fecha_fin,
        tipo_meta: "grupo",
        id_grupo: idGrupo.msg,
        id_usuario: "",
        agregado_por: localStorage.getItem("USERNAME"),
      };

      await EstadisticaService.createGoal(body)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData.description = `${resp.msg}`;
            this.snackbarData.openSnackbar = true;

            this.getGeneralGoals("en_proceso", idGrupo.msg);
          } else {
            this.snackbarData.description = `${resp.msg}`;
            this.snackbarData.openSnackbar = true;
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });

      this.closeDialog();
      this.dialogConfirmate.loading = false;
      this.dialogConfirmate.open = false;
    },
    updateGoal: async function () {
      this.dialogConfirmate.loading = true;
      let idMeta = await EstadisticaService.encriptar(
        this.formGroup.data.id_metaG
      );
      const STATUS = this.formFilter.data.status;
      let idGrupo = await EstadisticaService.encriptar(
        this.formGroup.data.id_grupo
      );

      let body = {
        id_meta: idMeta.msg,
        meta: this.formGroup.data.meta,
        estatus: this.formGroup.data.status,
        editado_por: localStorage.getItem("USERNAME"),
      };

      await EstadisticaService.updateGoal(body)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData.description = `${resp.msg}`;
            this.snackbarData.openSnackbar = true;

            this.getGeneralGoals(STATUS, idGrupo.msg);
          } else {
            this.snackbarData.description = `${resp.msg}`;
            this.snackbarData.openSnackbar = true;
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });

      this.closeDialog();
      this.dialogConfirmate.loading = false;
      this.dialogConfirmate.open = false;
    },
    getDataGrafica: async function () {
      let idMeta = await EstadisticaService.encriptar(
        this.formGroup.data.id_metaG
      );
      const FECHA_INICIAL = this.formGroup.data.fecha_inicio;
      const FECHA_FINAL = this.formGroup.data.fecha_fin;

      let arrDateInit = FECHA_INICIAL.split("-");
      let dateInitial = new Date(
        parseInt(arrDateInit[0]),
        parseInt(arrDateInit[1]) - 1,
        arrDateInit[2]
      );

      let arrDateFinal = FECHA_FINAL.split("-");
      let dateFinal = new Date(
        parseInt(arrDateFinal[0]),
        parseInt(arrDateFinal[1]) - 1,
        arrDateFinal[2]
      );

      let arrDates = this.getBetweenDates(dateInitial, dateFinal);
      let arrStrDate = [];
      for (const DATE of arrDates) {
        let year = DATE.getFullYear();
        let month =
          DATE.getMonth() + 1 < 10
            ? `0${DATE.getMonth() + 1}`
            : DATE.getMonth() + 1;
        let date = DATE.getDate() < 10 ? `0${DATE.getDate()}` : DATE.getDate();
        let strDate = `${year}-${month}-${date}`;
        arrStrDate.push(strDate);
      }

      await EstadisticaService.getDataGraficaMetas(idMeta.msg)
        .then((resp) => {
          if (!resp.error) {
            const data_grafica = resp.response.cobranza;
            let arrTemp = [];
            let arrDataTemp = [];
            for (let element of data_grafica) {
              let value = element.total;
              let fecha = element.fecha;
              arrDataTemp.push({
                x: fecha, // fecha
                y: value, // total
                goals: [
                  {
                    name: "Meta",
                    value: this.formGroup.data.meta, // Supongamos que la meta registrada es constante
                    strokeHeight: 5,
                    strokeColor: "#775DD0",
                  },
                ],
              });
            }
            arrTemp.push({
              name: `Actual`,
              data: arrDataTemp,
            });

            this.series = arrTemp;
          } else {
            this.snackbarData.description = `${resp.msg}`;
            this.snackbarData.openSnackbar = true;
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
    },
    getBetweenDates: function (initialDate, finalDate) {
      let arrDatesBetween = [];
      while (initialDate < finalDate) {
        arrDatesBetween.push(new Date(initialDate));
        initialDate.setDate(initialDate.getDate() + 1);
      }
      arrDatesBetween.push(finalDate);
      return arrDatesBetween;
    },
    sonFechasIguales: function (fecha1, fecha2) {
      const year1 = fecha1.getFullYear();
      const month1 = fecha1.getMonth();
      const day1 = fecha1.getDate();

      const year2 = fecha2.getFullYear();
      const month2 = fecha2.getMonth();
      const day2 = fecha2.getDate();

      return year1 === year2 && month1 === month2 && day1 === day2;
    },
  },
};
</script>

<style>
.actions {
  display: flex;
  align-items: center;
  float: left;
  margin-right: 15px;
  width: 9vh !important;
  height: 9vh !important;
}
</style>
